import { Logo } from "@cynthai/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { twMerge } from "tailwind-merge";

function AuthLayout() {
  return (
    <div
      className={`bg-background bg-auth-dots flex min-h-dvh w-screen items-center justify-center`}
    >
      <div
        className={`h-auth-height max-w-auth-width rounded-auth bg-background-2 relative flex w-full items-center justify-start`}
      >
        <div
          className={`bg-background-2 shadow-card absolute left-16 w-105 rounded-lg p-8`}
        >
          <Logo size={50} className="mb-4" />
          <Outlet />
        </div>

        <div
          className={twMerge(
            "ml-auto h-full w-3/4 bg-auth bg-cover bg-no-repeat",
          )}
        ></div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/auth")({
  component: AuthLayout,
});
